import supabase from '../supabaseClient';

// Único punto donde un pedido descuenta stock físico: al terminar.
// Crear/editar/cancelar solo tocan la reserva (pedidos_lineas + estado), nunca stock.
export const terminarPedidoConDescuento = async ({ pedido, lineas, numero_albaran, nj, usuario, almacen_id }) => {
  if (!lineas || lineas.length === 0) {
    return { ok: false, error: "El pedido no tiene líneas — añádelas antes de terminarlo." };
  }

  const detalles = [];
  for (const l of lineas) {
    let q = supabase.from('stock').select('*').eq('almacen_id', almacen_id).eq('referencia', l.referencia);
    q = l.fecha_caducidad ? q.eq('fecha_caducidad', l.fecha_caducidad) : q.is('fecha_caducidad', null);
    const { data: lote } = await q.maybeSingle();
    detalles.push({ linea: l, lote, fisicoCajas: lote?.cantidad_cajas || 0, fisicoPalets: lote?.cantidad_palets || 0 });
  }

  const faltantes = detalles.filter(d => d.fisicoCajas < (d.linea.cantidad_cajas || 0) || d.fisicoPalets < (d.linea.cantidad_palets || 0));
  if (faltantes.length > 0) {
    const detalle = faltantes
      .map(f => `${f.linea.referencia} (caduca ${f.linea.fecha_caducidad || "sin fecha"}): necesita ${f.linea.cantidad_cajas || 0} cajas / ${f.linea.cantidad_palets || 0} palets, hay ${f.fisicoCajas} / ${f.fisicoPalets} en stock físico`)
      .join("; ");
    return { ok: false, error: `Stock físico insuficiente para terminar — ajusta el inventario antes de continuar. ${detalle}` };
  }

  for (const { linea: l, lote, fisicoCajas, fisicoPalets } of detalles) {
    await supabase.from('movimientos_stock').insert({
      tipo: "salida",
      referencia: l.referencia,
      cantidad_cajas: l.cantidad_cajas,
      cantidad_palets: l.cantidad_palets,
      fecha_caducidad: l.fecha_caducidad,
      numero_albaran,
      usuario,
      almacen_id,
      motivo: `Pedido ${pedido.numero_pedido}`,
    });
    if (lote) {
      await supabase.from('stock').update({
        cantidad_cajas: fisicoCajas - (l.cantidad_cajas || 0),
        cantidad_palets: fisicoPalets - (l.cantidad_palets || 0),
      }).eq('id', lote.id);
    }
  }

  const terminado_en = new Date().toISOString();
  const payload = { estado: "terminado", terminado_en };
  if (nj) payload.nj = nj;
  await supabase.from('pedidos').update(payload).eq('id', pedido.id);

  return { ok: true, terminado_en };
};
